import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { toast } from "react-toastify";


const PersonalInformationModal = ({ userData, onUpdate }) => {
  const [editedData, setEditedData] = useState(userData);
  const [showWeddingDate, setShowWeddingDate] = useState(userData.martial_status === "married");
  const [errors, setErrors] = useState({});
  const submitButtonRef = useRef(null);


  useEffect(() => {
    setEditedData(userData);
    setShowWeddingDate(userData.martial_status === "married");
  }, [userData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedData({ ...editedData, [name]: value });
  };

  const handleDateChange = (date, name) => {
    setEditedData({ ...editedData, [name]: date });
  };

  const handleSelectChange = (selectedOption, name) => {
    const value = selectedOption.value;
    setEditedData({ ...editedData, [name]: value });

    if (name === "martial_status") {
      setShowWeddingDate(value === "married");
    }
  };

  const handleValidation = () => {
    const newErrors = {};
    if (!editedData.name) newErrors.name = "First Name is required";
    if (!editedData.lastname) newErrors.lastname = "Last Name is required";
    if (!editedData.father_name) newErrors.father_name = "Father/Spouse Name is required";
    if (!editedData.date_of_birth) newErrors.date_of_birth = "Birth Date is required";
    if (!editedData.present_address) newErrors.present_address = "Present Address is required";
    if (!editedData.permanent_address) newErrors.permanent_address = "Permanent Address is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (handleValidation()) {
      onUpdate(editedData);
         if (submitButtonRef.current) {
        submitButtonRef.current.click(); // Trigger the click event
      }


    } else {
      console.log("Form validation failed");
    }
  };

  //01722585300
  const nationalityOptions = [
    { value: "Indian", label: "Indian" },
    { value: "Foreigner", label: "Foreigner" },
  ];

  const martialStatusOptions = [
    { value: "single", label: "Single" },
    { value: "married", label: "Married" },
  ];

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "others", label: "Others" },
  ];

  const personalInfoDataR = [
    { title: "Passport number", name: "passport_number" },
    { title: "Visa number", name: "visa_number" },
    { title: "PAN No", name: "pan_no" },
    { title: "UAN No", name: "uan_no" },
    { title: "EPF No", name: "epf_no" },
    { title: "Social Security No", name: "social_security_number" },
    { title: "AADHAR Number", name: "aadhar_no" },
    { title: "Bank Name", name: "bank_name" },
    { title: "Bank A/c number", name: "bank_account_number" },
    { title: "IFSC Code", name: "ifsc_code" },
  ];

  return (
  <div id="personal_info_modal" className="modal custom-modal fade" role="dialog">
  <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "60%" }}>
    <div className="modal-content h-100">
      <div className="modal-header">
        <h5 className="modal-title">Personal Information</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body" style={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}>
        <form onSubmit={handleSubmit}>
          <div className="container">
            <div className="row">
              {/* Left Column */}
              <div className="col-md-6">
                {[
                  { title: "First Name", name: "name" },
                  { title: "Last Name", name: "lastname" },
                  { title: "Father/Spouse Name", name: "father_name" },
                  {
                    title: "Gender",
                    name: "gender",
                    options: genderOptions,
                  },
                  { title: "Birth Date", name: "date_of_birth", type: "date" },
                  { title: "Religion", name: "religion" },
                  {
                    title: "Nationality",
                    name: "nationality",
                    options: nationalityOptions,
                    handleChange: handleSelectChange,
                  },
                  { title: "Phone", name: "mobile" },
                  { title: "Personal Email", name: "personal_email" },
                  {
                    title: "Marital status",
                    name: "martial_status",
                    options: martialStatusOptions,
                    handleChange: handleSelectChange,
                  },
                  showWeddingDate && {
                    title: "Wedding Date",
                    name: "wedding_date",
                    type: "date",
                  },
                  { title: "Blood Group", name: "blood_group" },
                ].map((info) => info && (
                  <div key={info.name} className="input-block mb-3">
                    <label className="col-form-label">{info.title} <span className="text-danger">*</span></label>
                    {info.type === "date" ? (
                      <DatePicker
                        selected={editedData[info.name]}
                        onChange={(date) => handleDateChange(date, info.name)}
                        className="form-control"
                      />
                    ) : info.options ? (
                      <Select
                        options={info.options}
                        value={info.options.find(option => option.value === editedData[info.name])}
                        onChange={(selectedOption) => handleSelectChange(selectedOption, info.name)}
                      />
                    ) : (
                      <input
                        type="text"
                        className="form-control"
                        name={info.name}
                        value={editedData[info.name]}
                        onChange={handleChange}
                      />
                    )}
                    {errors[info.name] && (
                      <div className="text-danger">{errors[info.name]}</div>
                    )}
                  </div>
                ))}
              </div>
              {/* Right Column */}
              <div className="col-md-6">
                {personalInfoDataR.map((info) => (
                  <div key={info.name} className="input-block mb-3">
                    <label className="col-form-label">{info.title}</label>
                    <input
                      type="text"
                      className="form-control"
                      name={info.name}
                      value={editedData[info.name] || ""}
                      onChange={handleChange}
                    />
                  </div>
                ))}
                <div className="input-block mb-3">
                  <label className="col-form-label">Present Address <span className="text-danger">*</span></label>
                  <textarea
                    className="form-control"
                    name="present_address"
                    value={editedData.present_address || ""}
                    onChange={handleChange}
                  />
                  {errors.present_address && (
                    <div className="text-danger">{errors.present_address}</div>
                  )}
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">Permanent Address <span className="text-danger">*</span></label>
                  <textarea
                    className="form-control"
                    name="permanent_address"
                    value={editedData.permanent_address || ""}
                    onChange={handleChange}
                  />
                  {errors.permanent_address && (
                    <div className="text-danger">{errors.permanent_address}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer d-flex justify-content-center" style={{
            position: 'fixed',
            bottom: 0,
            right: 0,
            margin: 0,
            display: 'flex',
            justifyContent: 'center',
            padding: '0px',
            width: "60%"
          }}>
            <button type="submit" className="btn btn-primary">Save</button>
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Close</button>
          </div>
        </form>
        <div style={{ display: 'none' }}>
                <button
                  ref={submitButtonRef}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  type="reset"
                >
                  Submit2
                </button>
              </div>
      </div>
    </div>
  </div>
</div>

  );
};

export default PersonalInformationModal;
